/**
 * Forms App Theme Configuration
 */

import { AppThemeConfig } from '@crowdctrl/shared';

export const appThemeConfig: AppThemeConfig = {
  defaultTheme: 'rmit-light',
  availableThemes: [
    'arcade-dark',
    'arcade-light',
    'azure-depths',
    'default-dark',
    'default-light',
    'dreamgrove',
    'rmit-light',
    'sunset-light',
  ],
  appOverrides: {
    // Forms app can override specific colors if needed
  },
};
